export default {
  name: 'FooterForMobile'
};